export const API_PROPERTY_MANAGER_000 = {
  PROPERTY_ID: 'PROPERTY_ID',
  PROPERTY_LIST: 'PROPERTY_LIST',
  PROP_API_000_001: 'get_menu_list',
  PROP_API_000_002: 'get_header_info',
  PROP_API_000_003: 'update_favorite',
} as const;

export type ApiPropertyManagerKeys = keyof typeof API_PROPERTY_MANAGER_000;
export type ApiPropertyManagerValues = (typeof API_PROPERTY_MANAGER_000)[ApiPropertyManagerKeys];

export const AUTO_EXPAND_NAME = 'favourite,TOP,在庫調整,予約管理,料金更新';